module.exports = __webpack_public_path__ + "img/blog-4.1bf2fe78.png";